module.exports = __webpack_public_path__ + "static/media/2.df0105c8.jpg";